<m-panel
  class="fiche-repondant-card"
  :class="panelClasses"
  :shadow="true"
  @click="onPanelClick"
>
  <template #header>
    <h5>
      {{ ficheRepondant.prenom }} {{ ficheRepondant.nom }}
    </h5>
    <div class="fiche-repondant-card__header--statut">
      {{ $i18next.t(`modules.fiche-repondant.overview.FicheRepondantCard.label.statut.${ficheRepondant.statut}`) }}
      <m-icon
        :class="`fiche-repondant-card__statut-icon--${ficheRepondant.statut}`"
        :name="computeStatutIcon"
        :size="16"
      />
    </div>
  </template>
  <template v-for="casSpecial, index in ficheRepondant.casSpeciauxRepondant">
    <div class="fiche-repondant-card__cas-speciaux">
      <template v-if="casSpecial.horodateCasSpecial">
        <div class="fiche-repondant-card__cas-speciaux--timestamp">
          <m-icon name="m-svg__calendar" />
          &nbsp;&nbsp;{{ casSpecial.horodateCasSpecial.periode }}
        </div>
      </template>
      <template v-if="casSpecial.examen">
        <div class="fiche-repondant-card__cas-speciaux--examens">
          <m-icon name="m-svg__evaluation" />
          &nbsp;&nbsp;<span v-html="$i18next.t('modules.fiche-repondant.overview.FicheRepondantCard.label.titre_cours', casSpecial.examen)" />
        </div>
      </template>
      <template v-if="!mixin_string_isEmpty(casSpecial.villeEtudiant) && !mixin_string_isEmpty(casSpecial.paysEtudiant)">
        <div class="fiche-repondant-card__cas-speciaux--location">
          <location-svg />
          &nbsp;{{ $i18next.t('modules.fiche-repondant.overview.FicheRepondantCard.label.location', casSpecial) }}
        </div>
      </template>
      <template v-if="index < ficheRepondant.casSpeciauxRepondant.length - 1">
        <hr />
      </template>
    </div>
  </template>
  <div class="fiche-repondant-card__footer">
    <template v-if="ficheRepondant.isModifiableParEtudiant">
      <m-button
        :skin="MButtonSkin.Secondary"
        @click="onUpdateButtonClick"
      >
        {{ $i18next.t('modules.fiche-repondant.overview.FicheRepondantCard.button.update.label') }}
      </m-button>
    </template>
    <template v-if="ficheRepondant.isSupprimableParEtudiant">
      <m-button
        :skin="MButtonSkin.Secondary"
        @click.stop="onDeleteButtonClick"
      >
        {{ $i18next.t('modules.fiche-repondant.overview.FicheRepondantCard.button.delete.label') }}
      </m-button>
      <m-dialog
        :width="MDialogWidth.Large"
        :okLabel="$i18next.t('modules.fiche-repondant.overview.FicheRepondantCard.button.delete.label')"
        :open="isDeleteConfirmationDialogDisplayed"
        @ok="deleteFicheRepondant"
        @cancel="hideDeleteConfirmationDialog"
      >
        <m-message :state="MMessageState.Warning">
          <span v-html="$i18next.t('modules.fiche-repondant.overview.FicheRepondantCard.label.delete_confirmation')" />
        </m-message>
      </m-dialog>
    </template>
  </div>
</m-panel>